import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function NaplesAParis() {
  return <section data-section-id="223031" id="our-mission" className="relative py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_100%)] opacity-5" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="relative w-full max-w-xl mx-auto lg:mx-0 aspect-[4/5] sm:aspect-square lg:aspect-[4/5]">
            {}
            <div className="absolute top-0 left-0 w-[65%] h-[70%] rounded-none overflow-hidden shadow-none border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/parisian_street_napoli.png" alt="Modern legislative chamber" className="w-full h-full object-cover grayscale" />
              <div className="absolute inset-0 bg-primary/20" />
            </div>

            {}
            <div className="absolute bottom-0 right-[5%] w-[60%] h-[65%] rounded-none overflow-hidden shadow-none z-10 border-8 border-background">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/neapolitan_alley_napoli.png" alt="Data visualization interface" className="w-full h-full object-cover grayscale" />
              <div className="absolute inset-0 bg-primary/20" />
            </div>

            {}
            <div className="absolute top-[25%] left-[40%] w-[45%] aspect-square rounded-none overflow-hidden shadow-none z-20 border-8 border-background">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1644405/img/pizza_closeup_napoli.png" alt="Citizen advocacy in action" className="w-full h-full object-cover grayscale" />
              <div className="absolute inset-0 bg-primary/20" />
            </div>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-none bg-secondary text-secondary-foreground text-sm font-mono font-medium tracking-widest uppercase">
                <MapPin className="size-4 text-primary" />
                <span>Civic Empowerment</span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-[1.15] tracking-tighter">
                Empowering Citizens Through Data
              </h2>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground font-default tracking-normal leading-relaxed">
              <p>
                The Citizen Advocates Network (CAN) is a modern think tank dedicated to bridging the gap between people and power. Through a data-driven approach, we empower citizens to influence governments and promote responsive governance.
              </p>
              <p>
                Our mission is rooted in the belief that transparency and evidence-based advocacy are the cornerstones of a healthy democracy. We provide the tools and research necessary for meaningful civic participation.
              </p>
              <p>
                By synthesizing complex policy data into actionable insights, we help communities hold institutions accountable and ensure that the voices of the many are heard in the halls of the few.
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-none px-8 h-12 text-base bg-primary hover:bg-primary/90 transition-colors">
                <Link to="/our-team/">Our Team</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}